<div class="loading-shade" *ngIf="isLoading ">
	<mat-spinner diameter="80" *ngIf="isLoading"></mat-spinner>
</div>
<form [formGroup]="districtInfoForm" class="formEditSchoolDistrict paddingToAll">
	<mat-card appearance="outlined" class="cardSchoolDistrictProfile">
		<span class="floatRight"><button mat-icon-button color="primary" matTooltip="Close record"
				(click)="closeRecord()">
				<mat-icon class="centered-icon" style="position:relative;right:3px;">close</mat-icon>
			</button></span> 
		<mat-card-title-group>
			<mat-card-title>&nbsp;&nbsp;&nbsp;{{schoolDistrictName}}'s School District Profile<mat-icon></mat-icon>
			</mat-card-title>
			<!--
			<div class="floatRight"><button mat-icon-button color="primary" matTooltip="Edit record"
					(click)="editRecord()">
					<mat-icon>edit</mat-icon>
				</button></div> -->
		</mat-card-title-group>
		<mat-card-content>
			<b>Region: </b>&nbsp; {{regionCode}} - {{region}}<p></p>
			<b>County: </b>&nbsp; {{county}}<p></p>			
		</mat-card-content>
	</mat-card>
	<p><br></p>
	<mat-card-title>School District Information</mat-card-title>
	<mat-card appearance="outlined" class="cardSchoolDistrictInformation">
		<mat-card-title-group class="groupSchoolDistrictInformation">
		</mat-card-title-group>
		<mat-card-content>
			<table id="schoolDistrictInfoTable">
				<tr>
					<th> Name </th>
					<td> {{schoolDistrictName}} </td>
				</tr>
				<tr>
					<th> NCES Code </th>
					<td> {{schoolDistrictNCES}} </td>
				</tr>
				<tr>
					<th> District Code </th>
					<td> {{schoolDistrictCode}} </td>
				</tr>
			</table>
		</mat-card-content>
	</mat-card>
</form>